import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataOo from './phonics/phonics_data_oo';

function PhonicsOo() {
  return <PhonicsAtoZ letterData={letterDataOo} />;
}

export default PhonicsOo;
